import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueSocketIO from 'vue-socket.io'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-114030951-1',
  router,
  autoTracking: {
    pageviewOnLoad: true
  }
})
Vue.config.productionTip = false
//  old connection: 'https://ct.irsmarket.com:8181'   https://sio.irsmarket.com
Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://ct.irsmarket.com:8181',
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  },
  options: { path: '/socket.io/?chatID=cso&', transports: ['polling', 'websocket'] }
}))

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
